'use client';

/**
 * This file is used to make authenticated requests to the server.
 * It is used in the client side code only.
 * For server side code, use authorizedServerFetch from src\actions\server.actions.js
 */

import { getEnvBaseUrl, joinUrl } from '@utils/stringHelpers';
import { defaultsDeep } from 'lodash-es';

const proxyBaseUrl = `${getEnvBaseUrl()}/api/proxy/v2/protected`;

const fetchViaProxy = async (url, requestOptions) => {
  let i = 0;
  try {
    console.log('fetchViaProxy requestOptions', requestOptions);
    const remoteUrl = joinUrl(proxyBaseUrl, url);
    const response = await fetch(remoteUrl, requestOptions);
    if (!response.ok) {
      return {
        ok: false,
        status: response.status,
        data: null,
      };
    }

    const responseData = await response.json();
    return {
      ok: true,
      status: response.status,
      data: responseData,
    };
  } catch (e) {
    console.log('Error fetching data', e);
    return {
      ok: false,
      status: 500,
      data: null,
    };
  }
};

const putRequestWithAuth = async (url, data, options = {}) => {
  // console.log('putRequestWithAuth data', data);
  const payload = !data || data instanceof FormData ? data : JSON.stringify(data);
  const requestOptions = defaultsDeep(options, {
    method: 'PUT',
    body: payload,
  });

  // console.log('putRequestWithAuth requestOptions', requestOptions);

  return fetchViaProxy(url, requestOptions);
};

const getRequestWithAuth = async (url, options = {}) => {
  const requestOptions = defaultsDeep(options, {
    method: 'GET',
  });

  return fetchViaProxy(url, requestOptions);
};

const postRequestWithAuth = async (url, data, options = {}) => {
  const requestOptions = defaultsDeep(options, {
    method: 'POST',
    body: data ? JSON.stringify(data) : null,
  });
  return fetchViaProxy(url, requestOptions);
};

export { putRequestWithAuth, getRequestWithAuth, postRequestWithAuth };
